import { render, staticRenderFns } from "./PermisoProvisional.vue?vue&type=template&id=6bd34078&"
import script from "./PermisoProvisional.vue?vue&type=script&lang=js&"
export * from "./PermisoProvisional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports